<template>
    <!--
        Reserve the height of the LARGER (non-compact) variant on desktop so the
        runtime swap between `xl:text-3xl` (~30px) and `xl:text-base` (~16px) does
        not produce a vertical layout shift. The flex centering keeps both states
        visually aligned within the reserved box. This is the fix for the field
        CLS attributed to this scoped element by Lighthouse.
    -->
    <div class="flex w-full items-center justify-center py-2 xl:min-h-[66px]">
        <NuxtLink to="/nl/">
            <div class="text-center">
                <div
                    class="lg:mb-2 font-monument-extended text-sm uppercase leading-none"
                    :class="compactDesktopLogo ? 'xl:text-base' : 'xl:text-3xl'">
                    Ballegooyen
                </div>
                <div
                    class="font-monument-extended text-xs"
                    :class="compactDesktopLogo ? 'xl:text-xss' : 'xl:text-[20px]'">
                    modes
                </div>
            </div>
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        data: any;
    }>();

    const route = useRoute();

    /**
     * Shop sections use smaller desktop type. We deliberately key this off the URL
     * (and a prop the parent layout already has at SSR time) instead of the Pinia
     * `pageDataStore`. Pinia is populated by the page's async setup, which can
     * resolve AFTER this header component has been rendered into the SSR HTML —
     * causing the value to flip during hydration and producing CLS. Route path is
     * identical on SSR and the client, so the rendered class is stable.
     */
    const compactDesktopLogo = computed(() => {
        const path = route.path;
        if (path.includes('/heren') || path.includes('/dames')) {
            return true;
        }

        const isLocaleHome = /^\/[a-z]{2}\/?$/i.test(path);
        if (isLocaleHome) {
            return false;
        }

        const ctx = props.data?.context;
        if (ctx === 'men' || ctx === 'ladies') {
            return true;
        }
        return false;
    });
</script>
